import { useGetDatasetMapperData } from "api/api-hooks/dataset-mapper-hooks";

// eslint-disable-next-line import/prefer-default-export
export const useDatasetMappedIcon = (mapValue: number | undefined, mapperId: number) => {
  const { data, isLoading } = useGetDatasetMapperData(mapperId);

  if (
    isLoading ||
    mapValue === undefined ||
    !data?.mappingIcons ||
    !data.mappingIcons[mapValue] === undefined
  ) {
    return null;
  }

  return `pi ${data.mappingIcons[mapValue]}`;
};
